<template>
  <div class="cards-paganation">
    <div class="page-text">{{ currentPage }}/{{ totalPage }}</div>
    <ul class="dot-con">
      <li
        v-for="(item, index) in totalPage"
        :key="index"
        :class="['normal-dot', item <= currentPage ? 'active-dot' : 'normal-dot']"
      ></li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    currentPage: {
      type: Number || String,
      default: 1,
    },
    totalPage: {
      type: Number,
      default: 10,
    },
  },
}
</script>
<style lang="scss" scoped>
.cards-paganation {
  display: flex;
  align-items: center;
  padding: 0 24px;
  .page-text {
    color: #2c2f46;
    font-size: 14px;
    font-weight: 600;

    min-width: 45px;
  }
}
.dot-con {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  max-width: 210px;
}
.normal-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: 1px solid #b5b5be;
  background: #fff;
  margin: 3px;
}
.active-dot {
  background: #9141c7;
  border-color: #9141c7;
}
</style>
